import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col } from 'antd';
import CSRadioGroup from '../public/cs-radio-group';
import List from '../list/List';
import Theme from './Theme';
import AppList from '../mode/AppList';
import AllApp from './AllApp';

const store = [
  'homeStore',
  'listStore',
  'themeListStore',
  'modeListStore',
]

@inject(...store)
@observer
class App extends React.Component {

  componentDidMount() {
    const { location, modeListStore: { setMobxState, getModules } } = this.props;
    const id = location.query.id;
    // setMobxState({ searchType: id === 'all' ? 'workflow' : id });
    setMobxState({ searchType: id });
    getModules();
  }

  callApis = () => {
    const {
      location,
      listStore: { callAppData, callScreenData, params: { searchValue } },
      themeListStore: {
        getThemeList, params, setState
      },
      modeListStore: {
        getModeList, getMould, searchType,
      }
    } = this.props;
    const id = searchType;
    if (id === 'workflow') {
      callAppData(id);
      callScreenData(id, location.query);
    } else if (id === 'theme') {
      setState({ current: 1 });
      getThemeList({ title: searchValue, current: 1 });
    } else {
      getModeList({ searchValue, current: 1, module: getMould(id) });
    }
  }
  //-----------------------------------搜索结果分类---------------------------------------
  getRadioItems = () => {
    const { modeListStore: { searchType, modules } } = this.props;
    return [
      {
        key: 'searchTypes', name: '版块', data: [
          { key: 'all', name: '全部应用' },
          { key: 'workflow', name: '流程表单' },
          { key: 'theme', name: '门户主题' },
          { key: 'mode', name: 'E9建模模板' },
          { key: 'docViewTemplate', name: '文档显示模板' },
          { key: 'dev', name: '定制开发' },
          // { key: 'nStandard', name: '非标应用' },
          ...toJS(modules),
        ], defaultValue: searchType,
      }
    ]
  }

  onChange = (e) => {
    const { modeListStore: { routing, setMobxState, getMould }, homeStore, homeStore: { initTypes } } = this.props;
    const id = e.target.value;
    routing.push({
      pathname: '/app/search',
      query: {
        id,
      }
    });
    homeStore.setMobxState({ type: { id, name: initTypes[id] } });
    setMobxState({ searchType: id, modeType: getMould(id) });
    this.callApis();
  }

  render() {
    const { modeListStore: { searchType, modules }, width } = this.props;
    const id = searchType;
    if (id === 'all') return <AllApp modules={modules} {...this.props} />
    return (
      <div className={`search ${id === 'theme' && 'search-theme'}`}>
        <Row>
          <Col span={24}>
            <div style={{ paddingLeft: 95, paddingRight: 95 }}>
              <CSRadioGroup datas={this.getRadioItems()} onChange={this.onChange} />
            </div>
          </Col>
        </Row>
        {
          id === 'workflow' ? (<List {...this.props} />) :
            id === 'theme' ? (<Theme width={width} />) : (<AppList width={width} />)
        }
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/Search.js